import React from 'react';

import Icon from './Icon';

const ArrowPointIcon = (props) => {
    return (
        <Icon width='33' height='34' fill='none' {...props}>
            <path
                d='M19.3003 24.0152C19.4394 24.1616 19.665 24.1616 19.8041 24.0152C19.9433 23.8687 19.9433 23.6313 19.8041 23.4848L13.6434 17L19.8041 10.5152C19.9432 10.3687 19.9432 10.1313 19.8041 9.98483C19.665 9.83839 19.4394 9.83839 19.3003 9.98483C17.0788 12.3232 14.8573 14.6616 12.6357 17C14.8573 19.3384 17.0788 21.6768 19.3003 24.0152Z'
                className='fill-black dark:fill-white'
            />
        </Icon>
    );
};

export default ArrowPointIcon;
